document.addEventListener("DOMContentLoaded", () => {
  const faqScripts = [
    ...document.querySelectorAll('script[type="application/ld+json"]')
  ];

  const faqPages = [];

  faqScripts.forEach(script => {
    try {
      const json = JSON.parse(script.textContent);
      if (json["@type"] === "FAQPage" && Array.isArray(json.mainEntity)) {
        faqPages.push({ script, json });
      }
    } catch (e) {}
  });

  // Nothing to merge
  if (faqPages.length <= 1) return;

  const mergedMap = new Map();

  faqPages.forEach(({ json }) => {
    json.mainEntity.forEach(q => {
      if (q?.name) mergedMap.set(q.name.trim(), q);
    });
  });

  const mergedFAQ = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": Array.from(mergedMap.values())
  };

  // Keep the first FAQPage, remove the rest
  const primary = faqPages[0].script;
  primary.textContent = JSON.stringify(mergedFAQ);

  faqPages.slice(1).forEach(({ script }) => script.remove());
});
